import { Autocomplete } from 'stimulus-autocomplete'

export default class extends Autocomplete {
  static classes = ['option', 'empty']

  connect () {
    super.connect()
    this.doFetch = this.fetchJsonAndBuildHtml.bind(this)
    this.onAddressSearchResume = this.onAddressSearchResume.bind(this)
    this.inputTarget.addEventListener('focus', this.onAddressSearchResume)
    this.inputTarget.addEventListener('input', this.onAddressSearchResume)
  }

  disconnect () {
    if (this.hasInputTarget) {
      this.inputTarget.removeEventListener('focus', this.onAddressSearchResume)
      this.inputTarget.removeEventListener('input', this.onAddressSearchResume)
    }
    super.disconnect()
  }

  onAddressSearchResume () {
    window.dispatchEvent(new CustomEvent('map_address_confirm:hideNoPolygonWarning'))
  }

  optionsForFetch () {
    return {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      }
    }
  }

  async fetchJsonAndBuildHtml (url) {
    const response = await fetch(url, this.optionsForFetch())

    if (!response.ok) {
      throw new Error(`Server responded with status ${response.status}`)
    }

    const payload = await response.json()
    return this.buildResultsHtml(payload)
  }

  buildResultsHtml (payload) {
    if (payload.options?.length > 0) {
      return payload.options.map((option) => this.buildOptionHtml(option)).join('')
    }

    return this.buildEmptyHtml(payload.empty_message)
  }

  buildOptionHtml (option) {
    const li = document.createElement('li')
    li.setAttribute('role', 'option')
    li.dataset.autocompleteValue = option.value
    this.applyClasses(li, this.optionClasses)
    li.textContent = option.label
    return li.outerHTML
  }

  buildEmptyHtml (message) {
    const li = document.createElement('li')
    this.applyClasses(li, this.emptyClasses)
    li.textContent = message
    return li.outerHTML
  }

  applyClasses (element, classes) {
    classes.forEach((className) => {
      className.split(/\s+/).filter(Boolean).forEach((token) => element.classList.add(token))
    })
  }
}
